import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class NewMaintenanceStore {
  maintainVehicles = [];
  serviceData = [];
  maintenanceData = [];
  loading = false;
  total = 0;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      maintainVehicles: observable,
      loading: observable,
      total: observable,
      loadData: action,
      addData: action,
      getMaintenanceGridData: action,
      getServiceData: action,
      getVehicleMaitenanceData: action,
      deleteRecord: action,
      sampleExcel: action,
      addVehMainByExcel: action,
      getMaintenanceData: action,
      addMaintenance: action,
      addService: action,
      deleteGridRecord: action,
      serviceData: observable,
      maintenanceData: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    searchField,
    servicedateFrom,
    servicedateTo,
    vehicleId,
    offset,
    limit,
    isadmin,
    userId,
  }) {
    this.loading = true;
    var postData = {
      tokenId: "80bovn8u800tg1aq9bvr73kbhh",
      searchField: searchField,
      servicedateFrom: servicedateFrom,
      servicedateTo: servicedateTo,
      companyId: companyId,
      vehicleNo: vehicleId,
      userId: userId,
      isadmin: isadmin,
      offset: offset,
      limit: limit,
    };

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/newmaintenance/getNewMaintenance", {
        params: postData,
      });

    this.maintainVehicles = response?.data?.data?.maintenancedetails;
    this.total = parseInt(response.data.data?.TotalCount);
    this.loading = false;
  }

  async addData(maintenanceDetails) {
    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/newmaintenance/createorupdate",
        maintenanceDetails
      );
    return response;
  }

  async getServiceData(Id) {
    var postData = { Id: Id };

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/newmaintenance/getServiceTypes", {
        params: postData,
      });

    this.serviceData = response?.data?.data;
    return response?.data?.data;
  }

  async getMaintenanceData() {
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/newmaintenance/getMaintenanceTypes");

    this.maintenanceData = response?.data?.data;
    return response?.data?.data;
  }

  async getVehicleMaitenanceData({ Id, limit, offset, companyId }) {
    const postData = { Id: Id, limit: 1, offset: 0, companyId };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/newmaintenance/getNewMaintenance", {
        params: postData,
      });

    return response?.data?.data.maintenancedetails[0];
  }

  async deleteRecord({ Id }) {
    var response = await postApi
      .getClient("")
      .delete(config.NodeUrl + `/vehicle-maintenance/deleteMaintenance/${Id}`);
    return response;
  }

  async deleteGridRecord({ aId, maintenanceId }) {
    var postData = { aId: aId, maintenanceId: maintenanceId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=maintenance&a=deleteAdditionalService",
        "postData=" + base64Input
      );
    return response;
  }

  async getMaintenanceGridData(id) {
    var postData = { maintenanceId: id };
    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/newmaintenance/getgriddata", {
        params: postData,
      });
    return response?.data?.data;
  }

  async sampleExcel() {
    window.location.href =
      config.fleetURL + "/appRes/excel/SampleMaintainance.xlsx";
  }

  async addVehMainByExcel(excelFile) {
    this.excelLoadig = true;
    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/vehicle-maintenance/importmaintenance",
        excelFile
      );
    this.excelLoadig = false;
    return response.data;
  }

  async addMaintenance(data) {
    var postData = data;
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/newmaintenance/savemaintenancetype", postData);
    return response.data;
  }

  async addService(data) {
    var postData = data;
    var response = await postApi
      .getClient("")
      .post(config.NodeUrl + "/newmaintenance/saveservice", postData);
    return response.data;
  }
}

export default NewMaintenanceStore;
